import React from 'react';
import styled from 'styled-components';
import Surface from '../components/Surface';
import { Heading, Label, Accent } from '../components/Typography';

const PageWrapper = styled(Surface).attrs({ tone: 'base' })`
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const Inner = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PageLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.75rem;
`;

const PageTitle = styled(Heading)`
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  margin-bottom: 2.5rem;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const StatCard = styled(Surface).attrs({ tone: 'raised' })`
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 20px 40px rgba(56, 49, 45, 0.05);
`;

const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: none;

  &:not(:last-child) {
    margin-bottom: 0.35rem;
  }
`;

const StatKey = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: #665d58;
`;

const StatValue = styled.span`
  font-family: 'Epilogue', sans-serif;
  font-size: 0.9375rem;
  font-weight: 700;
  color: #38312d;
`;

const AgencyCard = styled(Surface).attrs({ tone: 'accent' })`
  padding: 1.75rem;
  border-radius: 1.25rem;
  margin-top: 1rem;
`;

const AgencyLabel = styled(Label)`
  display: block;
  color: #721f0f;
  margin-bottom: 0.5rem;
`;

const AgencyName = styled.p`
  font-family: 'Epilogue', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #38312d;
  margin-bottom: 0.5rem;
`;

const AgencyDetail = styled.p`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.9375rem;
  color: #38312d;
  line-height: 1.7;

  a {
    color: #a0412d;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let years = today.getFullYear() - birthDate.getFullYear();
  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
  ) {
    years--;
  }
  return `${years}y`;
};

const VitalStatistics = () => (
  <PageWrapper>
    <Inner>
      <PageLabel>Agency Profile</PageLabel>
      <PageTitle>Vital <Accent>Statistics.</Accent></PageTitle>

      <StatsGrid>
        <StatCard>
          <StatRow>
            <StatKey>Age</StatKey>
            <StatValue>{calculateAge('2014-03-07')}</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Gender</StatKey>
            <StatValue>Female</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Pronouns</StatKey>
            <StatValue>She/Her</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Ethnicity</StatKey>
            <StatValue>European</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Location</StatKey>
            <StatValue>Christchurch</StatValue>
          </StatRow>
        </StatCard>
        <StatCard>
          <StatRow>
            <StatKey>Hair</StatKey>
            <StatValue>Red</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Eyes</StatKey>
            <StatValue>Blue</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Height</StatKey>
            <StatValue>153cm</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Clothing</StatKey>
            <StatValue>12-14 kids</StatValue>
          </StatRow>
          <StatRow>
            <StatKey>Shoe</StatKey>
            <StatValue>US Women's 6</StatValue>
          </StatRow>
        </StatCard>
      </StatsGrid>

      <AgencyCard>
        <AgencyLabel>Represented by</AgencyLabel>
        <AgencyName>LBF Actors</AgencyName>
        <AgencyDetail>
          Email: <a href="mailto:liz@lbfactors.nz">liz@lbfactors.nz</a><br />
          Phone: 09 215 8296
        </AgencyDetail>
      </AgencyCard>
    </Inner>
  </PageWrapper>
);

export default VitalStatistics;
